var map = {
	"./App": 3115,
	"./App.vue": 3115,
	"./assets/images/data.png": 722,
	"./assets/images/hero_img.png": 7764,
	"./assets/images/orientation.png": 1533,
	"./assets/images/portfolio/1.png": 2303,
	"./assets/images/portfolio/2.png": 9309,
	"./assets/images/portfolio/3.png": 740,
	"./assets/images/portfolio/4.png": 6855,
	"./assets/images/portfolio/5.png": 750,
	"./assets/images/portfolio/87804078_3544945025579106_3321313156482990080_n.png": 5331,
	"./assets/images/portfolio/Home page.png": 3539,
	"./assets/images/portfolio/Web 1280 – 1.png": 1486,
	"./assets/images/portfolio/Web 1280 – 2.png": 6284,
	"./assets/images/portfolio/header.png": 346,
	"./assets/images/portfolio/landing page.png": 2329,
	"./assets/images/portfolio/landing page2.png": 4301,
	"./assets/images/portfolio/offer way landing page.png": 3430,
	"./assets/images/portfolio/screencapture-file-G-templets-Drseham-Dr-seham-index-html-2023-01-19-01_36_27.png": 6953,
	"./assets/images/portfolio/screencapture.png": 3727,
	"./assets/images/responsive.png": 2315,
	"./assets/images/screencapture-photography-38jp-vercel-app-2023-01-17-21_39_34.png": 1268,
	"./assets/images/web-design.png": 6509,
	"./components/About/About": 7249,
	"./components/About/About.vue": 7249,
	"./components/Contact/Contact": 8187,
	"./components/Contact/Contact.vue": 8187,
	"./components/Footer/Footer": 3868,
	"./components/Footer/Footer.vue": 3868,
	"./components/Main/Main": 2852,
	"./components/Main/Main.vue": 2852,
	"./components/MyServices/MyServices": 3109,
	"./components/MyServices/MyServices.vue": 3109,
	"./components/Nav/Navbar": 7047,
	"./components/Nav/Navbar.vue": 7047,
	"./components/Portfolio/portfolio": 2718,
	"./components/Portfolio/portfolio.vue": 2718,
	"./main": 866,
	"./main.js": 866
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 8116;